// extracted by mini-css-extract-plugin
export default {"backdrop":"Offcanvas_backdrop__Ewb7S","offcanvas":"Offcanvas_offcanvas__ReNvS","offcanvas_left":"Offcanvas_offcanvas_left__J-tTF","show":"Offcanvas_show__XGifN"};